/**
 * Enum for Olympus Access Level
 * @readonly
 * @enum {name: {value: string}}
 */

export enum ShiftCenterAccessLevel {
    'shift-center' = 'shift-center#default',
    'shift-builder' = 'shift-center#create-shift',
    'shift-assignment' = 'shift-center#assign-shift',
    'calendar' = 'team-calendar#default',
}
  